import { Text, Title } from '@mantine/core';
import { Button } from '../Button/Button';
import classes from './EventBanner.module.css';
import { Wrapper } from './EventBanner.style';

export type EventBannerProps = {
  mp4: string;
};

export function EventBanner(props: EventBannerProps) {
  const { mp4 } = props;

  return (
    <Wrapper className='EventBanner-wrapper' data-testid='EventBanner-wrapper'>
      {/* Background Video */}
      <video autoPlay loop muted playsInline className={classes.video}>
        <source src={mp4} type='video/mp4' />
        Your browser does not support the video tag.
      </video>

      {/* Content Overlay */}
      <div className={classes.wrapper}>
        <div className={classes.body}>
          <Title className={classes.title}>DND Hackathon</Title>
          <Text fw={500} fz='lg' mb={5}>
            December 24-26, 2024
          </Text>
          <Text fz='sm' c='dimmed'>
            Our annual hackathon is back! Join us of 3d printing, AI, and more. DND Hackathon is a
            3-day event where you can learn, build, and share your projects with the community.
          </Text>

          <div className={classes.controls}>
            <Button radius='xl' className={classes.control} size='md' color='pink'>
              Subscribe
            </Button>
          </div>
        </div>
        <img
          src='https://cdn.prod.website-files.com/62b61ea35d1d736623887bf7/673d8bdfc09880db8c85af09_axe-kopi.webp'
          className={classes.image}
        />
      </div>
    </Wrapper>
  );
}

export default EventBanner;
